import { typography } from './typography';
import { themeStrings } from './config';

const themes = {
  long: {
    name: 'long',
    ...typography,
    background: '#ffccd5',
    primary: 'black',
    secondary: 'white',
    accent: '#ffccd5',
    muted: '',
    gray: '',
    text: 'black',
  },
  short: {
    name: 'short',
    ...typography,
    background: 'blue',
    primary: 'white',
    secondary: '#ffccd5',
    accent: 'blue',
    muted: '',
    gray: '',
    text: 'white',
  },
};

export { themes, themeStrings };
